import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { SettingsType } from '@/api/apis/user';
import { queryClient } from '@/queries';
import { settingsQueries } from './settings.query';

export const useGetSettingsMutation = () => {
  return useMutation({
    mutationFn: () => api.communication.getSettings(),
    onSuccess: (data) => {
      queryClient.setQueryData(settingsQueries.settings().queryKey, data);
    },
  });
};

export const useUpdateSettingsMutation = () => {
  return useMutation({
    mutationFn: (data: SettingsType) => api.communication.updateSettings(data),
    onSuccess: (data) => {
      queryClient.setQueryData(settingsQueries.settings().queryKey, data);
    },
  });
};
